// Workflow panel configuration functions
import {
    ref,
    watch
} from "vue"

export function useWorkflowPanels() {
    // Set the mode of the workflow
    let mode = ref(null)

    let hero = ref(false)
    let search = ref(false)
    let main = ref(false)
    let help = ref(false)

    // Welcome panel alignment
    const welcomeSetup = () => {
        hero.value = true
        search.value = false
        main.value = false
    }

    // Create panel alignment
    const createSetup = () => {
        hero.value = false
        search.value = false
        main.value = true
    }

    // Edit Panel 
    const editSetup = () => {
        hero.value = false
        search.value = true
        main.value = true
    }

    // React to changes in the mode
    watch(mode, () => {
        console.log("MODE UPDATE", mode)
        if (mode.value === "welcome") welcomeSetup()
        if (mode.value === "create" || mode.value === "popup_create" || mode.value === "popup_edit") createSetup()
        if (mode.value === "approve_create" || mode.value === "popup_approve_create" || mode.value === "popup_approve_edit") createSetup()
        if (mode.value === "edit") editSetup()
    })

    return {
        mode,
        hero,
        search,
        main,
        help
    }

}